import { createSlice } from '@reduxjs/toolkit';
import { IReduxState } from '../../interfaces/IReduxState';
import { IDayOfWeekList } from '../../../Pages/Pricing/IPricing';

export const AddDayOfWeekSlicer = createSlice({
  name: 'AddDayOfWeek',
  initialState: {
    data: {},
    isLoading: false,
  } as IReduxState<IDayOfWeekList>,
  reducers: {
    addDayOfWeek: (state, _) => {
      state.isLoading = true;
    },
    successAddDayOfWeek: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    failureAddDayOfWeek: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    clearAddDayOfWeekState: (state) => {
      state.data = {};
    },
  },
});

export const {
  addDayOfWeek,
  failureAddDayOfWeek,
  successAddDayOfWeek,
  clearAddDayOfWeekState,
} = AddDayOfWeekSlicer.actions;

export default AddDayOfWeekSlicer.reducer;
